import { CustomizedCalendar } from "./_components/big-calendar/customized-calendar";

const EmployeeAttendance = () => {
  return (
    <div className="h-screen">
      <CustomizedCalendar />
    </div>
  );
};

export default EmployeeAttendance;
